import React from 'react';

// https://github.com/facebook/react/issues/3386#issuecomment-291152357
const HighlightWord = ({ text, query = '', icon }) => {
    if (!text) {
        return null;
    }

    const [beforeQuery, afterQuery] = query ? text.split(query) : [];
    const hasSplitQuery = beforeQuery && afterQuery;
    return (
        <span>
            {icon && icon}
            <span>{hasSplitQuery && <strong>{beforeQuery}</strong>}</span>
            <span>{hasSplitQuery ? query : text}</span>
            <span>{hasSplitQuery && <strong>{afterQuery}</strong>}</span>
        </span>
    );
};

export default HighlightWord;
